import React from "react";
import "./style.scss";

export const LoadingIcon = (): JSX.Element => {
    return (
        <div className="container-loading-icon"></div>
    );
}
